<template>
  <RouterLink
    :to="back"
    :aria-label="aria"
    data-gtm-back-button
    class="btn-back inline-flex items-center focus-a"
  >
    <IconBase :icon="icon" :color="iconcolor" :size="iconsize" />
    <span
      v-if="text"
      class="ml-2"
      :class="`text-${textcolor} text-${textsize}`"
    >
      {{ text }}
    </span>
  </RouterLink>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'BtnBack',

  components: {
    IconBase
  },

  props: {
    icon: {
      type: String,
      default: ''
    },
    iconsize: {
      type: String,
      default: '1.5rem'
    },
    iconcolor: {
      type: String,
      default: 'white'
    },
    text: {
      type: String,
      default: ''
    },
    textsize: {
      type: String,
      default: 'base'
    },
    textcolor: {
      type: String,
      default: 'black'
    },
    aria: {
      type: String,
      default: 'Back'
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters(['post']),

    back() {
      if (this.$route.meta.back === 'home' && this.post?.type === 'subject') {
        return { name: 'campus-category', params: { category_id: 'subjects' } }
      }
      return { name: this.$route.meta.back }
    }
  }
}
</script>
